import { PriceConverter } from '../helpers'
import PropTypes from 'prop-types'
import setQuery from 'set-query-string'
import { useEffect } from 'react'
import { trackEvent } from '../../gtm'
import { convertCurrency } from '../helpers/PriceConverter'
import { roundPrice } from '../../utils'

Steps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.object.isRequired,
      shortText: PropTypes.object.isRequired,
    }).isRequired
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
  showPrice: PropTypes.bool,
  totalPrice: PropTypes.number,
  currency: PropTypes.string,
  setStep: PropTypes.func.isRequired,
  dueNowData: PropTypes.shape({
    amountTotal: PropTypes.number,
    currencyToCharge: PropTypes.string,
  }),
}

export default function Steps({
  steps,
  currentStep,
  showPrice,
  totalPrice,
  currency,
  setStep,
  dueNowData = {},
}) {
  useEffect(() => {
    if(totalPrice) {
      trackEvent({
        checkout_cart_value: roundPrice(
          convertCurrency(totalPrice, currency, 'USD')
        ),
      })
    }
  }, [currentStep, totalPrice])

  return (
    <div className='checkout-wrapper progress-bar'>
      <div className='step-progress-bar'>
        {steps.map((step, index) => {
          const stepNumber = index + 1
          const setCurrentStep = () => {
            setQuery({}, { clear: true })
            setStep(stepNumber)
          }
          return (
            <div
              onClick={setCurrentStep}
              key={stepNumber}
              className={`step-progress-bar__item 
            ${currentStep > stepNumber ? 'finished' : ''}
            ${currentStep === stepNumber ? 'active' : ''}`}
            >
              <span className='step-progress-bar__step'>{stepNumber}</span>
              <span className='step-progress-bar__title full'>{step.text}</span>
              <span className='step-progress-bar__title short'>
                {step.shortText}
              </span>
              {steps.length !== stepNumber && (
                <span className='step-progress-bar__delimeter' />
              )}
            </div>
          )
        })}
        {currentStep !== 1 && !!totalPrice && !!showPrice && (
          <span className='total-price'>
            <PriceConverter
              amount={dueNowData.amountTotal || totalPrice}
              currency={dueNowData.currency || currency}
            />
          </span>
        )}
      </div>
    </div>
  )
}
